import React from 'react';
import { ArrowUpRight, BedDouble, Building2, Sparkles } from 'lucide-react';
import { RouteLink } from '../lib/router';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
const PATHWAYS = [{
  eyebrow: 'Stay Overnight',
  title: 'Retreat Stay',
  description: 'Boutique accommodation with a private pool, outdoor kitchen, and a quieter pace surrounded by nature.',
  to: '/stay',
  action: 'See the retreat stay',
  icon: BedDouble,
  image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6NDI3MDQ0NzQ%3D/original/f8c79b29-e4b3-444c-a36f-e29b7eb7c294.jpeg?im_w=1440',
  fallback: 'https://cdn.magicpatterns.com/uploads/6iFuFQHxKtTVkDK3NtymqK/543114991_122198079788570946_2516265263527440324_n.jpg'
}, {
  eyebrow: 'Pines Membership',
  title: 'Your regular reset',
  description: 'A membership currently in development for returning to the sauna, cold water, and community more often.',
  to: '/membership',
  action: 'Explore membership',
  icon: Sparkles,
  image: 'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg',
  fallback: 'https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg'
}, {
  eyebrow: 'Retreat Space',
  title: 'Host your gathering',
  description: 'A real place for workshops, breathwork, team days, retreats, music, and private events with room to settle in.',
  to: '/space',
  action: 'Explore the space',
  icon: Building2,
  image: 'https://cdn.magicpatterns.com/uploads/hffDynZX3nXn2CNTPNVY6M/471428511_122131322642570946_6342459253165615123_n.jpg',
  fallback: 'https://cdn.magicpatterns.com/uploads/tCCtuiYevJjrLRPGX4h7mj/470823327_122128867136570946_1434913759190205541_n.jpg'
}];
export function PathwayCards() {
  return <section className="bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-191" data-mp="3j082absqdk2o">
      <div className="mx-auto max-w-6xl" data-id="element-192" data-mp="3j2ucykax4fp4">
        <FadeIn data-id="element-193" data-mp="39bt1gujewpmn"><p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-194" data-mp="39c2t0mk3v4ug">Three ways to enjoy Pines Retreat</p></FadeIn>
        <FadeIn delay={0.1} data-id="element-195" data-mp="3dccyzz7wdv9b"><h2 className="mb-12 max-w-2xl font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-196" data-mp="2zeofaupkgu5u">Choose the rhythm that brings you here.</h2></FadeIn>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-197" data-mp="34ekiirqfwhkc">
          {PATHWAYS.map((pathway, index) => {
          const Icon = pathway.icon;
          return <FadeIn key={pathway.title} delay={index * 0.1} data-id="element-198" data-mp="xc2mdf9vrs9" data-mpi={index}>
                <RouteLink to={pathway.to} className="group block h-full overflow-hidden rounded-sm border border-pine/15 bg-creamDeep transition-colors hover:border-pine/35" data-id="element-199" data-mp="yvii2x0o0ti">
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-200" data-mp="3nass27qhjelg">
                    <SafeImage src={pathway.image} fallbackSrc={pathway.fallback} alt={pathway.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-201" data-mp="ew1zbry6jpg3" />
                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal/55 to-transparent" data-id="element-202" data-mp="24co40sjc1efu" />
                    <div className="absolute bottom-4 left-4 flex h-10 w-10 items-center justify-center rounded-sm bg-cream/90 text-pine" data-id="element-203" data-mp="1ze33es064sqv"><Icon className="h-5 w-5" data-id="element-204" data-mp="2d5hkgtaimjva" /></div>
                  </div>
                  <div className="flex flex-col p-6" data-id="element-205" data-mp="295z2a5a2wmw5">
                    <p className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-clay/65" data-id="element-206" data-mp="1lf3av99jbtpf">{pathway.eyebrow}</p>
                    <h3 className="mb-3 font-serif text-2xl text-pine" data-id="element-207" data-mp="1ggs3r6amjxaw">{pathway.title}</h3>
                    <p className="mb-6 flex-1 font-light leading-relaxed text-clay" data-id="element-208" data-mp="1ugazt0q5vi6u">{pathway.description}</p>
                    <span className="inline-flex items-center gap-2 font-medium text-ember" data-id="element-209" data-mp="1pgf5xub6h750">{pathway.action}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-210" data-mp="35uf3wzqgqmpm" /></span>
                  </div>
                </RouteLink>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}